<merri-loading-spinner [loading]="true" width="5" diameter="75"></merri-loading-spinner>
